export enum WorkflowFormFieldTypeEnum {
  Label,
  Textfield,
  Textarea,
  Combobox,
  Checkbox,
  Radiobutton,
  DatePicker,
  FileField,
  Spacer,
  CalculationField,
  MultiFileField,
  NumericField,
  TemplateField
}

export const NO_OPTIONS_FIELD_TYPES = [
  WorkflowFormFieldTypeEnum.Label,
  WorkflowFormFieldTypeEnum.Textfield,
  WorkflowFormFieldTypeEnum.Textarea,
  WorkflowFormFieldTypeEnum.DatePicker,
  WorkflowFormFieldTypeEnum.FileField,
  WorkflowFormFieldTypeEnum.Spacer,
  WorkflowFormFieldTypeEnum.CalculationField,
  WorkflowFormFieldTypeEnum.MultiFileField,
  WorkflowFormFieldTypeEnum.NumericField,
  WorkflowFormFieldTypeEnum.TemplateField
];

export const OPTION_BASED_FIELD_TYPES = [
  WorkflowFormFieldTypeEnum.Combobox,
  WorkflowFormFieldTypeEnum.Checkbox,
  WorkflowFormFieldTypeEnum.Radiobutton
];

export enum WorkflowConstraintActionEnum {
  Required,
  Optional,
  Disabled,
  Hidden,
  Visible
}

export enum WorkflowFormTemplateStateEnum {
  Draft = 0,
  Published,
  Archived
}

export enum WorkflowFormTemplatePrefixTypeEnum {
  Text,
  Date,
  None,
  Fiscal
}
export const MAX_PREFIX_LENGTH = 8;

export enum WorkflowFormTemplateConfigHeaderTypeEnum {
  Table,
  Email
}

export enum WorkflowConstraintConditionTypeEnum {
  OptionBased,
  ValueBased
}

export enum WorkflowConstraintConditionComparisonOperators {
  Equals,
  NotEquals,
  GreaterThan,
  LessThan,
  GreaterThanOrEqual,
  LessThanOrEqual,
  Contains
}

// Access Computation Node Constants
import {
  PredicateNodeBinaryOperators,
  PredicateNodeOperandSubtype
} from '../predicate/predicate.constant';

export const AccessPredicateNodeBinaryOperators = PredicateNodeBinaryOperators;

export type AccessPredicateNodeBinaryOperators = typeof AccessPredicateNodeBinaryOperators[keyof typeof AccessPredicateNodeBinaryOperators];

export const AccessPredicateNodeOperandSubtype = PredicateNodeOperandSubtype;
export type AccessPredicateNodeOperandSubtype = typeof AccessPredicateNodeOperandSubtype[keyof typeof AccessPredicateNodeOperandSubtype];

export enum AccessTargetType {
  User = 1,
  Group = 2
}
